"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountInfoTag = exports.AccountStatus = exports.AccountType = exports.BUAccountTokenUsage = void 0;
var BUAccountTokenUsage;
(function (BUAccountTokenUsage) {
    BUAccountTokenUsage["refresh"] = "refresh";
    BUAccountTokenUsage["access"] = "access";
})(BUAccountTokenUsage = exports.BUAccountTokenUsage || (exports.BUAccountTokenUsage = {}));
var AccountType;
(function (AccountType) {
    AccountType["phoneNumber"] = "phone_number";
    AccountType["email"] = "email";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["confirmed"] = "confirmed";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var AccountInfoTag;
(function (AccountInfoTag) {
    AccountInfoTag["master"] = "master";
    AccountInfoTag["bind"] = "bind";
})(AccountInfoTag = exports.AccountInfoTag || (exports.AccountInfoTag = {}));
